import { commonFilter } from './filter';

export default {
  pageName: 'Summary',
  pageId: '20023',
  pagePath: '/opinion/Summary',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    // 头部切换，已删除
    // C_tab: {
    //   buttonId: '200230',
    // },
    // 时间筛选器点击
    C_time: {
      buttonId: '200231',
    },
    C_translate: {
      buttonId: '200234',
    },
    // 情感分选择
    HC_totalSentimentTab: {
      buttonId: '200235',
    },
    // event 点击
    HC_event: {
      buttonId: '200236',
    },
    HC_summary: {
      buttonId: "2002315"
    },
    HC_list: {
      buttonId: "2002316"
    },
    HC_download: {
      buttonId: "2002317"
    },
    HC_summaryChange: {
      buttonId: "2002318"
    },
    HC_feedsChange: {
      buttonId: "2002319"
    },
    HC_summaryFeedsChange: {
      buttonId: "2002320"
    },
    // 单条记录点击
    HC_feedDetail: {
      buttonId: '200238',
    },
    HC_feedOriginUrl: {
      buttonId: '2002321',
    },
    // keyword点击,已删除
    // HC_keyword: {
    //   buttonId: '200237',
    // }, 
    // Feeds情感分点击
    // HC_sentimentTab: {
    //   buttonId: '200239',
    // },
    // 语言筛选器，已删除
    // C_language: {
    //   buttonId: '200232',
    // },
    // 添加筛选器按钮,已删除
    // C_addFilter: {
    //   buttonId: '200233',
    // },
    TT_tab: {
      buttonId: '2002310',
    },
    TT_topic: {
      buttonId: '2002311',
    },
    TT_keyword: {
      buttonId: '2002312',
    },
    TT_feed: {
      buttonId: '2002313',
    },
    C_filterType: {
      buttonId: '2002314',
    },
    ...commonFilter,
  },
};
